<template>
    <div>
        <div class="min-h-screen" :class="pageTypeData.activeTab === 1 ? 'bg-[#F6F6F4]' : ''">
            <div class="sticky top-0 py-10 px-15 bg-white z-20">
                <div class="flex items-center justify-around">
                    <div
                        v-for="item in pageTypeData.tabs"
                        :key="item.id"
                        class="flex flex-col items-center"
                        :class="pageTypeData.activeTab === item.id ? 'font-bold text-[#CF8C57]' : 'text-[#9D9D9D]'"
                        @click="handleChangeTab(item)"
                    >
                        <div class="text-16 leading-22">{{ item.title }}</div>
                        <div class="mt-2 w-18 h-3 rounded-full" :class="pageTypeData.activeTab == item.id ? 'bg-[#CF8C57]' : ''"></div>
                    </div>
                </div>

                <van-radio-group
                    v-if="pageTypeData.activeTab === 1 || pageTypeData.activeTab === 4"
                    v-model="ttype"
                    @change="handleChangeType"
                    direction="horizontal"
                    class="mt-15 ml-10 mr-10 flex">
                  <van-radio :name="1" checked-color="#FF9933" class="justify-center flex-1">理疗项目</van-radio>
                  <van-radio :name="2" checked-color="#FF9933" class="justify-center flex-1" v-if="pageTypeData.activeTab === 1">服务套餐</van-radio>
                  <van-radio :name="3" checked-color="#FF9933" class="justify-center flex-1">检查检验</van-radio>
                </van-radio-group>
            </div>

            <template v-if="pageTypeData.activeTab === 1">
                <van-loading class="py-20" size="24px" vertical v-show="prescriptionData.loading">加载中...</van-loading>
                <div class="mt-20 text-center text-14 text-[#898989]" v-show="!prescriptionData.loading && emptyArray(prescriptionData.list)">暂无数据</div>

                <div class="px-15" v-show="!emptyArray(prescriptionData.list)">
                  <van-list
                      :ref="'vanList'"
                      :name="'orderHistory'"
                      v-model="prescriptionData.loading"
                      :finished="prescriptionData.finished"
                      @load="getHistoryListData"
                      :offset="30"
                      finished-text="加载完成"
                  >
                    <div class="mt-12 pb-30 rounded-10 overflow-hidden shadow px-20 bg-white bg-gradient-1" v-for="item in prescriptionData.list" :key="item.id">
                      <div class="mt-15 flex items-center">
                        <div class="text-16 leading-22 font-bold">{{ item.username }}</div>
                        <div class="ml-6 w-16 h-16 rounded-3 bg-[#FF9933] text-center leading-16 text-10 text-white" v-if="item.seetypename">{{ item.seetypename }}</div>

                        <div class="ml-auto text-14 leading-20 text-[#9D9D9D]">{{ item.see_time }}</div>
                      </div>

                      <div class="mt-8 text-[#9D9D9D] text-14 leading-20">
                        <span>{{ item.usersex }}</span>
                        <span class="ml-4">{{ item.age }}</span>
                        <span class="ml-4">{{ item.phone }}</span>
                      </div>

                      <div class="mt-10 h-1 bg-[#D8D8D8]"></div>

                      <div class="mt-10 flex justify-between text-14 leading-20">
                        <div class="w-84 mr-20 flex-shrink-0 text-[#555555]">开单诊所</div>
                        <div class="text-[#9D9D9D]">{{ item.clinic_name }}</div>
                      </div>

                      <div class="mt-10 flex justify-between text-14 leading-20">
                        <div class="w-84 mr-20 flex-shrink-0 text-[#555555]">医生</div>
                        <div class="text-[#9D9D9D]">{{ item.doctor_name }}</div>
                      </div>

                      <div class="mt-10 flex justify-between text-14 leading-20">
                        <div class="w-84 mr-20 flex-shrink-0 text-[#555555]">诊断</div>
                        <div class="text-[#9D9D9D]">{{ item.diagnose }}</div>
                      </div>

                      <div class="mt-10 flex justify-between text-14 leading-20">
                        <div class="w-84 mr-20 flex-shrink-0 text-[#555555]">理疗单</div>
                        <div class="text-[#9D9D9D]">{{ item.prescription }}</div>
                      </div>

                      <div class="mt-15 mx-auto w-120 __button _primary" @click="handleImportOrder(item)">确定引入</div>
                    </div>
                  </van-list>
                </div>
            </template>

            <template v-else-if="pageTypeData.activeTab === 2 || pageTypeData.activeTab === 3">
                <van-loading class="py-20" size="24px" vertical v-show="prescriptionData.loading">加载中...</van-loading>
                <div class="mt-20 text-center text-14 text-[#898989]" v-show="!prescriptionData.loading && emptyArray(prescriptionData.list)">暂无数据</div>

                <div class="p-15" v-show="!emptyArray(prescriptionData.list)">
                  <van-list
                      :ref="'vanList'"
                      :name="'orderHistory'"
                      v-model="prescriptionData.loading"
                      :finished="prescriptionData.finished"
                      @load="getHistoryListData"
                      :offset="30"
                      finished-text="加载完成"
                  >
                    <div class="mt-12 pb-30 rounded-10 overflow-hidden shadow px-20 bg-white bg-gradient-1" v-for="item in prescriptionData.list" :key="item.id">
                      <div class="mt-15 flex items-center">
                        <div class="text-16 leading-22 font-bold">{{ item.t_name }}</div>
                        <div class="ml-6 w-16 h-16 rounded-3 bg-[#FF9933] text-center leading-16 text-10 text-white" v-if="item.seetypename">{{ item.seetypename }}</div>

                        <div class="ml-auto text-14 leading-20"
                             :style="{ color: item.exec_status === 4 ? '#16A34A' : '#EF4444' }">
                          {{ item.exec_status_name }}
                        </div>
                      </div>

                      <div class="mt-10 h-1 bg-[#D8D8D8]"></div>

                      <div class="mt-10 flex justify-between text-14 leading-20">
                        <div class="w-84 mr-20 flex-shrink-0 text-[#555555]">预约时间</div>
                        <div class="text-[#9D9D9D]">{{ item.appointment_time }}</div>
                      </div>

                      <div class="mt-10 flex justify-between text-14 leading-20">
                        <div class="w-84 mr-20 flex-shrink-0 text-[#555555]">执行时间</div>
                        <div class="text-[#9D9D9D]">{{ item.exec_time }}</div>
                      </div>

                      <div class="mt-10 flex justify-between text-14 leading-20">
                        <div class="w-84 mr-20 flex-shrink-0 text-[#555555]">{{ pageTypeData.activeTab === 2 ? '治疗师' : '检查师' }}</div>
                        <div class="text-[#9D9D9D]">{{ item.disp_name ? item.disp_name : '--' }}</div>
                      </div>

                      <div class="mt-10 flex justify-between text-14 leading-20" v-if="pageTypeData.activeTab === 2">
                        <div class="w-84 mr-20 flex-shrink-0 text-[#555555]">治疗备注</div>
                        <div class="text-[#9D9D9D]">{{ item.treat_remark ? item.treat_remark : '--' }}</div>
                      </div>

                      <div class="mt-10 flex justify-between text-14 leading-20">
                        <div class="w-84 mr-20 flex-shrink-0 text-[#555555]">执行诊所</div>
                        <div class="text-[#9D9D9D]">{{ item.exec_clinic_name }}</div>
                      </div>
                    </div>
                  </van-list>
                </div>
            </template>

            <template v-else-if="pageTypeData.activeTab === 4">
              <van-loading class="py-20" size="24px" vertical v-show="prescriptionData.loading">加载中...</van-loading>
              <div class="mt-20 text-center text-14 text-[#898989]" v-show="!prescriptionData.loading && emptyArray(prescriptionData.list)">暂无数据</div>

              <div class="px-15" v-show="!emptyArray(prescriptionData.list)">
                <div class="mt-12 rounded-10 overflow-hidden shadow px-20 bg-white bg-gradient-1" v-for="item in prescriptionData.list" :key="item.id">
                  <div class="mt-15 mb-15 flex items-center">
                    <div class="text-16 leading-22 font-bold">{{ item.t_name }}</div>
                    <div class="ml-6 w-16 h-16 rounded-3 bg-[#FF9933] text-center leading-16 text-10 text-white" v-if="item.seetypename">{{ item.seetypename }}</div>

                    <div class="ml-auto text-14 leading-20 text-[#9D9D9D]">余：{{ item.num }}</div>
                  </div>
                </div>
              </div>
            </template>
        </div>

    </div>
</template>

<script>
import { emptyArray } from "../../utils";
import { wxqrytreathistory} from "@/api/medical";
import { mapGetters } from "vuex";

export default {
    name: "checkItemsHistory",
    components: {},
    data() {
        return {
            ttype:1,
            userIdData: {
                userid: null,
                customerid: null,
                id:null
            },

            pageTypeData: {
                activeTab: 1,
                tabs: [
                    { id: 1, title: "开单历史" },
                    { id: 2, title: "治疗历史", first: true },
                    { id: 3, title: "检查历史", first: true },
                    { id: 4, title: "剩余次数", first: true },
                ],
            },

            // 开单历史
            prescriptionData: {
                page: 1,
                loading: false,
                noData: false,
                finished: false,
                badge:0,
                list: [], // 处方列表
            },


        };
    },
    computed: {
        ...mapGetters(["username"]),

    },
    methods: {
        emptyArray,

        /**
         * 切换tab
         */
        handleChangeTab(item) {
            this.pageTypeData.activeTab = item.id;

            this.ttype = 1;
            this.prescriptionData.list = [];
            this.prescriptionData.page = 1;
            this.prescriptionData.badge = 0;
            this.prescriptionData.finished = false;

            this.getHistoryListData();
        },

        handleChangeType(val){
          this.ttype = val;
          this.prescriptionData.list = [];
          this.prescriptionData.page = 1;
          this.prescriptionData.badge = 0;
          this.prescriptionData.finished = false;

          this.getHistoryListData()
        },

        /**
         * 获取历史处方列表数据
         */
        async getHistoryListData() {
            try {
                this.prescriptionData.loading = true;

                const requestData = Object.assign({ username: this.username,type:this.pageTypeData.activeTab,ttype: this.ttype,page: this.prescriptionData.page }, this.userIdData);
                console.log("data: ",requestData)
                const { response_body: res } = await wxqrytreathistory(requestData);

                if (!Array.isArray(res.list) || res.list.length === 0) {
                  this.prescriptionData.noData = true;
                  return;
                }

                this.prescriptionData.list = this.prescriptionData.list.concat(res.list);
                this.prescriptionData.page++;
                this.prescriptionData.loading = false;
                this.prescriptionData.badge = res.count;

                if (this.prescriptionData.list.length >= res.count) {
                  this.prescriptionData.finished = true;
                }

            } catch (error) {
                console.error(error);
            } finally {
                this.prescriptionData.loading = false;
            }
        },

        /**
         * 导入药方
         */
        handleImportOrder(item) {
            this.$store.commit("setImportTreatCheckData", {
                id: item.order_id,
                type: this.ttype,
            });

            this.$router.back();
        },
    },
    created() {
        this.$store.dispatch("hideOrShowNav", false);

        for (const key in this.userIdData) {
            this.userIdData[key] = this.$route.query[key];
        }

        this.getHistoryListData();
    },
};
</script>
<style lang="scss" scoped>
.bg-gradient-1 {
    background-image: linear-gradient(to bottom, rgba(207, 140, 87, 0.2), transparent 75px);
}

.myCollapse {
    ::v-deep {
        .van-collapse-item__title {
            height: 40px;
            background: #f4f4f4;
        }
        .van-collapse-item__content {
            padding: 0;
        }
    }
}
</style>
